export default __webpack_public_path__ + "static/media/newlogo-sidebar.ef9ac490.svg";